import { Routes } from '@angular/router';
import { logsRoute } from './logs.route';
import { RouteSubComponent } from 'authorization';
export const logsRouting: Routes = [
  {
    path: 'dashboard',
    data: {
      breadcrumb: {
        skip: true,
      },
      title: '',
    },
    loadComponent: () =>
      import(
        'src/domains/theme/app/component/full-layout/full-layout.component'
      ).then((c) => c.FullLayoutComponent),
    children: [
      {
        path: 'logs',
        loadComponent: () =>
          import('./app/component/system-logs/system-logs.component').then(
            (c) => c.SystemLogsComponent,
          ),
        data: {
          breadcrumb: {
            skip: true,
          },
        },
      } as RouteSubComponent<typeof logsRoute.map.dashboard, 'logs'>,

      {
        path: 'login_history',
        loadComponent: () =>
          import('./app/component/login-history/login-history.component').then(
            (c) => c.LoginHistoryComponent,
          ),
        data: {
          breadcrumb: {
            skip: true,
          },
        },
      } as RouteSubComponent<typeof logsRoute.map.dashboard, 'login_history'>,
    ],
  } as RouteSubComponent<typeof logsRoute.map, 'dashboard'>,
];
